import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { buildNumber } from './buildNumber.js'

function Footer() {
  return (
    <>
      <Row className="footer mt-4">
        <Col className="d-flex justify-content-center">
          <span className="" style={{ fontSize: "12px" }}>Build v{buildNumber}</span>
        </Col>
      </Row>
    </>
  );
}

export default Footer;